import React from 'react';
import { useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';

import { ContentClass } from '../../app/Shared/enums';
import {
  selectDetailsStockItem,
  selectDetailsStockItemIsContentClass,
} from '../selectors/detailsSelectors';

const StockItemContributor = () => {
  const { contributor } = useSelector(selectDetailsStockItem);
  const isVideoOrImageDetailsPage = useSelector(
    (state) =>
      selectDetailsStockItemIsContentClass(ContentClass.Video)(state) ||
      selectDetailsStockItemIsContentClass(ContentClass.Image)(state)
  );

  if (!contributor) return null;

  return (
    <div className="stockItemInfo-stockSpecContributor">
      <span className="stockItemInfo-stockSpecItemKey">Contributor: </span>
      <span className="stockItemInfo-stockSpecItemValue">
        <a
          className={twMerge(
            'contributor-link',
            isVideoOrImageDetailsPage && 'text-white font-bold'
          )}
          href={contributor.portfolioLink}
        >
          {contributor.username}
        </a>
      </span>
    </div>
  );
};

export default StockItemContributor;
